<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
    <el-form-item label="选项设置">
      <el-checkbox-group v-model="value.type">
        <el-checkbox v-for="op in types" :key="op.value" :label="op.value">{{op.label}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "PositionAreaInputConfig",
  components: { draggable },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      types: [
        { label: '公共', value: 2 },
        { label: '客房', value: 1 }
      ],
      dragOption: {
        animation: 300,
        sort: true
      }
    }
  },
  created() {
    console.log(this.value)
  },
  methods: {

  }
};
</script>

<style scoped>
::v-deep .options {
  .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
  }

  .el-icon-rank {
    padding-right: 5px;
    cursor: move;
  }

  .option-item {
    .el-input {
      width: 250px;
      float: right;
    }
  }
}

.option-item-label {
  height: 30px;
  line-height: 30px;

  button {
    float: right;
  }
}

/*/deep/ .el-form-item {
  margin-bottom: 10px;

  .el-form-item__label {
    padding: 0;
  }
  .options{
    .el-icon-rank{
      cursor: move;
    }
  }
}*/
</style>
